import 'jquery-mask-plugin';

const moduleName = 'telMask';

export function telMask() {

    Array.from(document.querySelectorAll('input[type=tel]')).forEach((self) => {
        if (self.dataset[moduleName + 'Init'] === 'true') return;
        self.dataset[moduleName + 'Init'] = true;

        const entry = self;

        $(entry).mask('+38 (000) 000-00-00', {
            clearIfNotMatch: true
        });

        entry.addEventListener('focus', () => {
            if (entry.value.length == 0) {
                entry.value = '+38 (';
                setTimeout(() => {
                    entry.setSelectionRange(entry.value.length, entry.value.length);
                }, 10);
            }
        });
    });

}